import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { bpHistory } from 'global/bpHistory';
import InitiateGroupForm from 'components/initiate-group';
import { GeneralRouteV2Id, ROUTES_CONFIG_V2 } from 'routes/routesConfigV2';
import InitiateGroupPageStore, {
  InitiateGroupPageStoreContext,
  useInitiateGroupPageStore,
} from 'store/pages/initiate-group/pageStore';

const initiateGroupRoute = ROUTES_CONFIG_V2[GeneralRouteV2Id.INITIATE_GROUP];

const PageContent: React.FC = observer(() => {
  const { isActionLoading, canCompleteStep, createGroupAndNavigateToInitiateProposal } = useInitiateGroupPageStore();

  const onBackRedirect = (): void => {
    bpHistory.goBack();
  };

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isActionLoading={isActionLoading}
      pageHeader={{
        title: initiateGroupRoute.title,
        subtitle: initiateGroupRoute.subtitle,
        onBackButtonClick: onBackRedirect,
      }}
      pageFooter={{
        onBack: onBackRedirect,
        onComplete: createGroupAndNavigateToInitiateProposal,
        completeButtonText: 'Create new group',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <InitiateGroupForm />
    </NoSidebarPageLayout>
  );
});

const InitiateGroupPage: React.FC = () => {
  const pageStore = useMemo(() => new InitiateGroupPageStore(), []);

  return (
    <InitiateGroupPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </InitiateGroupPageStoreContext.Provider>
  );
};

export default InitiateGroupPage;
